module.exports = __webpack_public_path__ + "img/step3_en-GB.3489b314.png";